<template>
  <div class="flights">
    <div class="row">
      <div class="col-md-4">
        <h1>Flights</h1>
      </div>
      <div class="col-md-8">
        <div class="buttons" style="float:right">
          <router-link to="/flights/create" class="button p-3" v-if="userRole == 1">New flight</router-link>
          <router-link :to="{name:'flight-time-changes'}" class="button p-3" v-if="userRole == 1">Update Bulk Flights</router-link>
          <button class="button p-3" v-if="userRole == 1" @click="syncFlightTimes">Sync Fligh Times</button>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="box">
    
          <form @submit.stop.prevent="doSearch" class="box__header form--inline">
            <input v-model="quickSearch" type="search" placeholder="Search by flight no.">
            <button class="button button--small" type="submit">Search</button>
          </form>
    
          <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="options"
            @edit="editFlight"
            @delete="deleteFlight"
            @viewInstance="viewInstance"
            >
          </vdtnet-table>
    
        </div>
        <!-- box -->
      </div>
    </div>


  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
import moment from 'moment'
export default {
  name: 'flights',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  created () {
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'flights/table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
        order: [[6, 'desc']],
      },
      fields: {
        flight_number: {
          label: 'Flight Number',
          render: (data, type,row) => {
            return `<a href="/flights/edit/${ row.id }">${ row.flight_number }</a>`
          },
        },
        departure_time: {
          label: 'Departing on:',
          defaultOrder: 'asc',
          render: (data) => {
            return (data !== null ? moment(data).format('DD/MM/YYYY<br/>hh:mm A') : '–')
          },
          searchable: false
        },
        departure_airport: {
          label: 'Departing from:',
          render: (data) => {
            return (data !== null ? data.iata_code + '<br/><small>' + data.airport_name + '</small>' : '–')
          },
          searchable: false
        },
        arrival_airport: {
          label: 'Arriving at:',
          render: (data) => {
            return (data !== null ? data.iata_code + '<br/><small>' + data.airport_name + '</small>' : '–')
          },
          searchable: false
        },
        arrival_time: {
          label: 'Arriving on:',
          render: (data) => {
            return (data !== null ? moment(data).format('DD/MM/YYYY<br/>hh:mm A') : '–')
          },
          searchable: false
        },
        selected_airline: {
          label: 'Airline',
          render: (data, t, f, m) => {
            return f.selected_airline.name
          },
          searchable: false
        },
        edit: {
          searchable: false,
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            return `<a href="/flights/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        },
        delete: {
          searchable: false,
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            if (this.userRole == 1) {
              return `<a href="/flights/${ row.id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
            } else {
              return ''
            }
          }
        }
      },
      quickSearch: ''
    }
  },
  methods: {
    findAirportName(data) {
      this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'airports/' + data, {
          headers: {
            'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          var result = response.data[0].airport_name
          return result
        })
    },
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    editFlight(data) {
      this.$router.push({ name: 'flight-edit', params: { id: data.id }})
    },
    deleteFlight(data) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'flights/' + data.id + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$refs.table.reload()
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    viewInstance(data) {
      this.$router.push({ name: 'flight-instance', params: { id: data.id }})
    },
    syncFlightTimes() {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "This will sync all flight times with the flightsAPI. This process may take a few minutes.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, sync flight times!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.performSync()
        } 
      })
    },
    performSync() {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'flights/syncing/flight-times', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.status) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}

</script>
